import { render, staticRenderFns } from "./BookingAgentAccounts.vue?vue&type=template&id=1680f3f9"
import script from "./BookingAgentAccounts.vue?vue&type=script&lang=js"
export * from "./BookingAgentAccounts.vue?vue&type=script&lang=js"
import style0 from "./BookingAgentAccounts.vue?vue&type=style&index=0&id=1680f3f9&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports